import { api } from './client';

export const alarmApi = {
  getAlarms: async (orgId: string, status?: string, severity?: string) => {
    const response = await api.get(`/alarms/${orgId}`, {
      params: { status, severity },
    });
    return response.data;
  },

  getActiveAlarms: async (orgId: string) => {
    const response = await api.get(`/alarms/${orgId}`, {
      params: { status: 'active' },
    });
    return response.data;
  },

  acknowledgeAlarm: async (alarmId: string, reason?: string) => {
    const response = await api.post(`/alarms/${alarmId}/ack`, {
      reason: reason || 'Acknowledged',
    });
    return response.data;
  },

  resolveAlarm: async (alarmId: string, reason?: string) => {
    const response = await api.post(`/alarms/${alarmId}/resolve`, {
      reason: reason || 'Resolved',
    });
    return response.data;
  },

  escalateAlarm: async (alarmId: string, level: number, reason?: string) => {
    const response = await api.post(`/alarms/${alarmId}/escalate`, {
      level,
      reason: reason || `Escalated to level ${level}`,
    });
    return response.data;
  },
};
